import { useEffect, useState } from 'react';
import { PIPELINE_VERSION_EVENT, getPipelineVersion } from '../util/pipelineVersion';

/**
 * Current pipeline version, kept in step with the Account page setting so the
 * sidebar and Record page update as soon as it changes.
 */
export function usePipelineVersion() {
  const [version, setVersion] = useState(getPipelineVersion);

  useEffect(() => {
    const sync = () => setVersion(getPipelineVersion());
    window.addEventListener(PIPELINE_VERSION_EVENT, sync);
    return () => window.removeEventListener(PIPELINE_VERSION_EVENT, sync);
  }, []);

  return version;
}
